<template>
  <div class="seu-main-header overline">
    <div class="main-container">
      <div class="asset-container">
        <router-link to="/">
          <img src="../../assets/logo/seu-logo.svg" alt="">
        </router-link>
      </div>

      <div class="menu-item-container">
        <menu-item
          v-for="menuItem in navigationMenuItems"
          :key="menuItem.label"
          :label="menuItem[currentLanguage].label"
          :route="menuItem.route"
          :params="{slug:menuItem[currentLanguage].slug}"
        />
      </div>
      <language-picker/>
    </div>

  </div>
</template>

<script>
import MenuItem from "../../components/MenuItem";
import LanguagePicker from "/seu-frontend/components/LanguagePicker";
import navigationMenu from "../../services/data/navigationMenu"
import {mapState} from "vuex";

export default {
  name: "SeuMainHeader",
  components: {LanguagePicker, MenuItem},
  data: () => ({navigationMenuItems: navigationMenu}),
  computed: {
    ...mapState({
      currentLanguage: state => state.currentLanguage.toLowerCase(),
    }),
  }

}
</script>

<style lang="scss">
@import "SeuMainHeader";
</style>
